import { createBrowserRouter, useNavigate } from "react-router";
import Layout from "./Layout.jsx";
import AccountBuilder from "./components/account/builder/AccountBuilder.jsx";
import DepartmentBuilder from "./components/departmentBuilder/DepartmentBuilder.jsx";
import AccountBuilderMultiStepForm from "./components/account/builder/AccountBuilderMultiStepForm.jsx";
import Accounts from "./components/account/Accounts.jsx";
import AccountHierarchy from "./components/account/AccountHierarchy.jsx";
import HomeGuide from "./components/home/HomeGuide.jsx";
// import AccountDetails from "./components/account/AccountDetails.jsx";
import Templates from "./components/benefitPlan/Templates.jsx";
// import BenefitPlanTemplatesDetail from "./components/benefitPlan/BenefitPlanTemplatesDetail.jsx";
//import BenefitPlanComponent from "./components/benefitPlan/BenefitPlanComponent.jsx";
// import BenefitPlanBuilder from "./components/benefitPlan/BenefitPlanBuilder.jsx";
// import BenefitPlanBuilderPoc from './components/benefitPlan/BenefitPlanBuilder.jsx'
// import BenefitPlanDraftReview from "./components/benefitPlan/BenefitPlanDraftReview.jsx";
// import BenefitPlanRider from "./components/benefitPlan/BenefitPlanRider.jsx";
// import HrpGuideChat from "./components/chat/HrpGuideChat.jsx";
import HrpGuide from "./components/guide/HrpGuide.jsx";
import AccessDashboard from "./components/access/AccessDashboard.jsx";
import RoleAccess from "./components/access/RoleAccess.jsx";
import Settings from "./components/settings/Settings.jsx";
// import Projects from "./components/project/Projects.jsx";
import Blogs from "./components/blog/Blogs.jsx";
import BlogPost from "./components/blog/BlogPost.jsx";
import BlogCompose from "./components/blog/BlogCompose.jsx";
import Tickets from "./components/support/Tickets.jsx";
import BenefitPlanMultiStepForm from "./components/benefitPlan/builder/BenefitPlanMultiStepForm.jsx";
import BenefitPlans from "./components/benefitPlan/BenefitPlans.jsx";
import { Navigate, Outlet } from "react-router";
import Login from "./components/auth/Login.jsx";
import ProtectedRoutes from "./ProtectedRoutes.jsx";
import PreLoginRoutes from "./PreLoginRoutes.jsx";
import BuilderDashboard from "./components/benefitPlan/builder/BuilderDashboard.jsx";
import ServiceCategories from "./components/services/ServiceCategories.jsx";
import DiagnosisCodes from "./components/diagnosis/DiagnosisCodes.jsx";
import ServiceCodes from "./components/services/ServiceCodes.jsx";
import Claims from "./components/claims/Claims.jsx";
import ClaimsGuide from "./components/claims/ClaimsGuide.jsx";
import Ingestion from "./components/edi/Ingestion.jsx";
import Members from "./components/member/Members.jsx";
import ValueListTable from "./components/benefitPlan/ValueListTable.jsx";
import BenefitPlanProvision from "./components/benefitPlan/BenefitPlanProvision.jsx";
import BenefitPlanAudit from "./components/benefitPlan/BenefitPlanAudit.jsx";
import MigrateBenefitPlan from "./components/benefitPlan/builder/MigrateBenefitPlan.jsx";
import Notifications from "./components/notifications";
import Outbox from "./components/notifications/Outbox";
import TestEmailTemplate from "./components/notifications/TestEmailTemplate";
import Suppliers from "./components/provider/Suppliers.jsx";
import Practitioners from "./components/provider/Practitioners.jsx";
import SupplierContracts from "./components/provider/SupplierContracts.jsx";
import FeeComponents from "./components/provider/FeeComponents.jsx";
import ProviderNetworks from "./components/provider/ProviderNetworks.jsx";
import ProviderGuide from "./components/provider/ProviderGuide.jsx";
import PractitionerRoles from "./components/provider/PractitionerRoles.jsx";
import BenefitPlanComponents from "./components/benefitPlan/BenefitPlanComponents.jsx";
import NetworkDefinitions from "./components/benefitPlan/NetworkDefinitions.jsx";
import MemberCareChatbot from "./components/chat/MemberCareChatbot.jsx";
import QInConnect from "./components/connect/QInConnect.jsx";
import OpensearchKnowledgebase from "./components/knowledgebase/OpensearchKnowledgebase.jsx";
import OpensearchKnowledgebaseCallSumary from "./components/knowledgebase/OpensearchKnowledgebaseCallSumary.jsx";
import FinanceChatbot from "./components/chat/FinanceChatbot.jsx";
import { fetchGetState } from "./utils/apiUtils.js";
import Member from "./components/member/Member.jsx";
import LogGroups from "./components/cloudwatch/LogGroups.jsx";
import Clients from "./components/javelina/Clients.jsx";
import Employees from "./components/javelina/Employees.jsx";
import HrpTable from "./components/dynamodb/HrpTable.jsx";
import Employee from "./components/javelina/Employee.jsx";
import OpensearchHrpGuide from "./components/knowledgebase/OpensearchHrpGuide.jsx";
import CodeEntries from "./components/services/CodeEntries.jsx";
import CodeCatalog from "./components/services/CodeCatalog.jsx";
import BankAccounts from "./components/finance/BankAccounts.jsx";
import JVBankAccounts from "./components/javelina/BankAccounts.jsx";
import JVPayments from "./components/javelina/Payments.jsx";
import Payments from "./components/finance/Payments.jsx";
import HrpCheckReportGenerator from "./components/finance/HrpCheckReportGenerator.jsx";
import PayeeBankAccounts from "./components/finance/PayeeBankAccounts.jsx";
import BillingRateBuilderRoute from "./components/finance/BillingRateBuilderRoute.jsx";
import NotificationTable from "./components/dynamodb/NotificationTable.jsx";
import Brokers from "./components/javelina/Brokers.jsx";
import DailyCheckJournal from "./components/javelina/DailyCheckJournal.jsx";
import BenefitPlansTable from "./components/dynamodb/BenefitPlansTable.jsx";
import NotificationsJobRegistry from "./components/dynamodb/NotificationsJobRegistry.jsx";
import JobDetails from "./components/jobRegistry/JobDetails.jsx";
import Jobs from "./components/jobRegistry/Jobs.jsx";
import Groups from "./components/jobRegistry/Groups.jsx";
import Cognito from "./components/jobRegistry/Cognito.jsx";
import GroupDetails from "./components/jobRegistry/GroupDetails.jsx";
import PcpTransactionTable from "./components/dynamodb/PcpTransactionTable.jsx";
import BusinessTable from "./components/dynamodb/BusinessTable.jsx";
import ReferralTable from "./components/dynamodb/ReferralTable.jsx";
import ClaimAndAccumulatorTable from "./components/dynamodb/ClaimAndAccumulatorTable.jsx";
import MemberTable from "./components/dynamodb/MemberTable.jsx";
import ServiceMember from "./components/athena/ServiceMember.jsx";
import FinanceInboundInvoices from "./components/finance/FinanceInboundInvoices.jsx";
import JvClaims from "./components/javelina/Claims.jsx";
import JvReinsurance from "./components/javelina/Reinsurance.jsx";
import FinanceGuide from "./components/finance/FinanceGuide.jsx";
import FinanceOpsDashboard from "./components/finance/FinanceOpsDashboard.jsx";
import StopLossSelfService from "./components/stoploss/stoploss-selfservice/StopLossSelfService.jsx";
import EdiExtractSelfService from "./components/edi-extract/edi-extract-selfservice/EdiExtractSelfService.jsx";
import BillRuns from "./components/finance/BillRuns.jsx";
import BillRunDetail from "./components/finance/BillRunDetail.jsx";
import FundingRequests from "./components/finance/FundingRequests.jsx";
import FundingRequestDetail from "./components/finance/FundingRequestDetail.jsx";
import PaymentCycles from "./components/finance/PaymentCycles.jsx";
import BillingRates from "./components/finance/BillingRates.jsx";
import PremiumPayments from "./components/finance/PremiumPayments.jsx";
import PremiumPaymentDetail from "./components/finance/PremiumPaymentDetail.jsx";
import AgentsChatbot from "./components/agents/AgentsChatbot.jsx";
import Coverage from "./components/coverage/Coverage.jsx";
import HrpDocs from "./components/hrpDocs/HrpDocs.jsx";
import FinanceDocs from "./components/finance/FinanceDocs.jsx";
import AccountAudit from './components/account/AccountAudit.jsx';

function getRandomStringFromArray(arr) {
    if (!Array.isArray(arr) || arr.length === 0) {
        return null; // Or throw an error, depending on desired behavior for empty/invalid input
    }
    const randomIndex = Math.floor(Math.random() * arr.length);
    return arr[randomIndex];
}

const notFoundJokes = [
    "Oops! The page you're looking for has gone on a coffee break. Please try again later.",
    "404 Error: Page not found. Maybe it's hiding in the same place as my motivation.",
    "This page is like a unicorn—mythical and nowhere to be found.",
    "Sorry, but this page has taken a vacation to Mars. It might be back soon.",
    "404: The page you're looking for is lost in the Bermuda Triangle of the internet.",
    "Oops! The page you're looking for has been abducted by aliens. We're working on getting it back.",
    "This page is like a ninja—it came, it saw, it vanished without a trace.",
    "404: The page you're looking for is hiding under a rock. We'll find it soon!",
    "Sorry, but this page has gone rogue and is now a rebel in the digital world.",
    "This page is like a ghost—it was here, but now it's gone. Spooky, right?",
    "404: The page you're looking for has been eaten by a grumpy internet troll.",
    "Oops! The page you're looking for has taken a wrong turn and is now lost in the digital wilderness.",
    "This page is like a magician—it disappeared right before your eyes.",
    "404: The page you're looking for has been kidnapped by a mischievous internet gremlin.",
    "Sorry, but this page has decided to take a nap and will be back when it's well-rested."
]

const NotFound = () => {
    const navigate = useNavigate()
    return <div className="not-found">
        <p>{getRandomStringFromArray(notFoundJokes)}</p>
        <button className="btn" onClick={() => navigate(-1)}>Go back</button>
    </div>
}

const chatDetailsLoader = async ({ params: { threadId }, request }) => {

    const url = new URL(request.url);
    const skipLoader = url.searchParams.get("skipLoader"); // Or check state if passed

    if (skipLoader) {
        // Return pre-existing data or null to indicate no new fetch
        return [];
    }

    //const res = await fetch(`http://localhost:3001/check-pointer/getState?threadId=${threadId}`)
    const chatDetails = await fetchGetState({
        threadId
    }) //res.json()

    const newMessages = chatDetails?.values?.messages
        // .filter(msgObj => !msgObj.id.includes('SystemMessage'))
        ?.map(msgObj => {

            if (msgObj.id.includes('HumanMessage')) {
                return {
                    id: msgObj.kwargs.id,
                    content: msgObj.kwargs.content
                }
            }
            else if (msgObj.id.includes('SystemMessage')) {
                return {
                    agent: { messages: [msgObj] }
                }

            } else if (msgObj.id.includes('AIMessageChunk') || msgObj.id.includes('AIMessage')) {
                return {
                    agent: { messages: [msgObj] }
                }
            } else if (msgObj.id.includes('ToolMessage')) {
                return {
                    tool: { messages: [msgObj] }
                }
            }


            return
        })

    return newMessages
}

//TODO create auth and role based routes
let router = createBrowserRouter([
    {
        path: "/",
        Component: Layout,
        children: [
            {
                id: "home",
                element: <ProtectedRoutes />,
                children: [
                    {
                        index: true,
                        Component: HomeGuide,
                    },
                ],
            },
            {
                path: "/blog",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: Blogs },
                    { path: "new", Component: BlogCompose },
                    { path: ":id/edit", Component: BlogCompose },
                    { path: ":id", Component: BlogPost },
                ],
            },
            // {
            //     id: "general-chat",
            //     path: '/general-chat',
            //     element: <PreLoginRoutes />,
            //     children: [

            //         {
            //             index: true,
            //             Component: GeneralChatWindow,
            //         }
            //     ]

            // },
            {
                id: "opensearch",
                path: '/opensearch',
                element: <ProtectedRoutes />,
                children: [

                    {
                        index: true,
                        Component: OpensearchKnowledgebase,
                    },
                    {
                        path: 'hrp-guide',
                        Component: OpensearchHrpGuide,
                    },
                    {
                        path: 'call-summary',
                        Component: OpensearchKnowledgebaseCallSumary,
                    }
                ]

            },
            {
                id: "login",
                path: '/login',
                element: <PreLoginRoutes />,
                children: [
                    {
                        index: true,
                        Component: Login,
                    }
                ]

            },
            // {
            //     path: "/chatbots",
            //     element: <ProtectedRoutes />,
            //     children: [
            //         {
            //             path: "plans",
            //             Component: GeneralChatWindow,
            //             children: [
            //                 {
            //                     id: 'stateByThreadId',
            //                     path: ":threadId",
            //                     Component: GeneralChatWindow,
            //                     // element: <GeneralChatWindow loaderData={chatDetailsLoader} />,
            //                     loader: chatDetailsLoader
            //                 }
            //             ]
            //         },
            //     ]
            // },
            {
                path: "/agents",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: AgentsChatbot },
                    { path: ":threadId", Component: AgentsChatbot },
                ]
            },
            {
                path: "/member-care",
                element: <ProtectedRoutes />,
                children: [
                    {
                        path: "chatbot",
                        Component: MemberCareChatbot,
                        children: [
                            {
                                id: 'getStateByThreadId',
                                path: ":threadId",
                                Component: MemberCareChatbot,
                                // element: <GeneralChatWindow loaderData={chatDetailsLoader} />,
                                loader: chatDetailsLoader
                            }
                        ]
                    },
                    {
                        path: "knowledge-base",
                        Component: OpensearchKnowledgebase
                    },
                    {
                        path: "call-summary",
                        Component: OpensearchKnowledgebaseCallSumary
                    }
                ]
            },
            {
                path: "/finance",
                element: <ProtectedRoutes />,
                children: [
                    {
                        path: "chatbot",
                        Component: FinanceChatbot,
                        children: [
                            {
                                id: 'getFinanceStateByThreadId',
                                path: ":threadId",
                                Component: FinanceChatbot,
                                // element: <GeneralChatWindow loaderData={chatDetailsLoader} />,
                                loader: chatDetailsLoader
                            }
                        ]
                    },
                    {
                        path: "knowledge-base",
                        Component: OpensearchKnowledgebase
                    },
                    {
                        path: "bank-account",
                        Component: BankAccounts
                    },
                    {
                        path: "payment",
                        Component: Payments
                    },
                    {
                        path: "payee-bank-accounts",
                        Component: PayeeBankAccounts
                    }

                    , {
                        path: "hrp-check-report-generator",
                        Component: HrpCheckReportGenerator
                    },
                    {
                        path: "billing-rate-builder",
                        Component: BillingRateBuilderRoute
                    }, {
                        path: "inbound-invoices",
                        Component: FinanceInboundInvoices
                    },
                    {
                        path: "docs",
                        children: [
                            { index: true, Component: FinanceDocs },
                            { path: "*", Component: FinanceDocs },
                        ],
                    },
                    { path: "guide", Component: FinanceGuide },
                    { path: "ops", Component: FinanceOpsDashboard },
                    { path: "bills", Component: BillRuns },
                    { path: "bills/:billFactKey", Component: BillRunDetail },
                    { path: "funding-requests", Component: FundingRequests },
                    { path: "funding-requests/:fundingRequestFactKey", Component: FundingRequestDetail },
                    { path: "payment-cycles", Component: PaymentCycles },
                    { path: "billing-rates", Component: BillingRates },
                    { path: "payments", Component: PremiumPayments },
                    { path: "payments/:paymentKey", Component: PremiumPaymentDetail },
                    { path: "premium-payments/:paymentKey", Component: PremiumPaymentDetail }
                ]
            },
            {
                path: "/stoploss",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: StopLossSelfService }
                ]
            },
            {
                path: "/monitoring",
                element: <ProtectedRoutes />,
                children: [
                    {
                        path: "groups",
                        Component: Groups,
                        children: [
                            {
                                id: 'groups',
                                path: ":groupPk/:groupSk",
                                Component: GroupDetails
                            }
                        ]
                    },
                    {
                        path: "jobs",
                        Component: Jobs,
                        children: [
                            {
                                id: 'jobs',
                                path: ":jobPk/:jobSk",
                                Component: JobDetails
                            }
                        ]
                    },
                    {
                        path: "cognito",
                        Component: Cognito,
                    },
                ]
            },

            {
                path: "/support",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: Tickets },
                    { path: "tickets", Component: Tickets },
                    { path: "q-in-connect", Component: QInConnect },
                ]
            },
            {
                path: "/access",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: AccessDashboard },
                    { path: "roles", Component: RoleAccess },
                ]
            },
            {
                path: "/settings",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: Settings }
                ]
            },
            {
                path: "/hrp-docs",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: HrpDocs },
                    { path: "*", Component: HrpDocs },
                ]
            },
            {
                path: "/members",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: Members },
                    { path: ":memberHccId/:activeTab?", Component: Member },
                ]
            },
            {
                path: "/coverage",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: Coverage },
                ]
            },
            {
                path: "/logs",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: LogGroups },
                    { path: ":logGroup", Component: LogGroups },
                ]
            },
            {
                path: "/claims",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: Claims },
                    { path: "guide", Component: ClaimsGuide },
                ]
            },
            {
                path: "/notifications",
                element: <ProtectedRoutes />,
                children: [
                    {
                        Component: Notifications,
                        children: [
                            { index: true, Component: Outbox },
                            { path: "outbox", Component: Outbox },
                            { path: "test-email-template", Component: TestEmailTemplate },
                        ],
                    },
                ]
            },
            {
                path: "/dynamodb",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: HrpTable },
                    { path: "hrp", Component: HrpTable },
                    { path: 'business', Component: BusinessTable },
                    { path: "pcp-transactions", Component: PcpTransactionTable },
                    { path: "benefitplans", Component: BenefitPlansTable },
                    { path: "notification", Component: NotificationTable },
                    { path: 'notifications-job-registry', Component: NotificationsJobRegistry },
                    { path: 'referral', Component: ReferralTable },
                    { path: 'claim-and-accumulator', Component: ClaimAndAccumulatorTable },
                    { path: 'member', Component: MemberTable },
                    { path: 'finance-inbound-invoices', Component: FinanceInboundInvoices }
                ]
            },
            {
                path: "/athena",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: ServiceMember },
                    { path: "service-member", Component: ServiceMember },
                ]
            },
            {
                path: "/edi",
                element: <ProtectedRoutes />,
                children: [
                    { path: "ingestion", Component: Ingestion },
                    { path: "extract", Component: EdiExtractSelfService }
                ]
            },
            // {
            //     path: '/access',
            //     Component: AccessDashboard
            // },
            {
                path: "/codes",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: ServiceCodes },
                    {
                        path: "services", Component: ServiceCodes
                    },
                    {
                        path: "diagnosis", Component: DiagnosisCodes
                    },
                    {
                        path: "code-entries", Component: CodeEntries
                    },
                    { path: "revenue", element: <CodeCatalog catalogId="revenue" /> },
                    { path: "drugs", element: <CodeCatalog catalogId="drugs" /> },
                    { path: "place-of-service", element: <CodeCatalog catalogId="place-of-service" /> },
                    { path: "type-of-bill", element: <CodeCatalog catalogId="type-of-bill" /> },
                    { path: "modifiers", element: <CodeCatalog catalogId="modifiers" /> },
                    { path: "procedures", element: <CodeCatalog catalogId="procedures" /> },
                    { path: "condition", element: <CodeCatalog catalogId="condition" /> },
                    { path: "occurrence", element: <CodeCatalog catalogId="occurrence" /> },

                ]
            },
            {
                path: "/providers",
                element: <ProtectedRoutes />,
                children: [
                    { index: true, Component: Suppliers },
                    {
                        path: "guide", Component: ProviderGuide
                    },
                    {
                        path: "suppliers", Component: Suppliers
                    },
                    {
                        path: "practitioners", Component: Practitioners
                    },
                    {
                        path: "roles", Component: PractitionerRoles
                    },
                    {
                        path: "contracts", Component: SupplierContracts
                    },
                    {
                        path: "fee-components", Component: FeeComponents
                    },
                    {
                        path: "networks", Component: ProviderNetworks
                    }
                ]
            },
            {
                path: '/jv',
                element: <ProtectedRoutes />,
                children: [
                    {
                        path: "clients",
                        children: [
                            {
                                index: true,
                                Component: Clients
                            },
                            {
                                path: ":clientId",
                                Component: Clients
                            }
                        ]
                    },
                    {
                        path: "brokers",
                        children: [
                            {
                                index: true,
                                Component: Brokers
                            },
                            {
                                path: ":brokers",
                                Component: Brokers
                            }
                        ]
                    },
                    {
                        path: "bank-account",
                        children: [
                            {
                                index: true,
                                Component: JVBankAccounts
                            },
                            {
                                path: ":clientId",
                                Component: JVBankAccounts
                            }
                        ]
                    },
                    {
                        path: "payments",
                        children: [
                            {
                                index: true,
                                Component: JVPayments
                            },
                            {
                                path: ":clientId",
                                Component: JVPayments
                            }
                        ]
                    },
                    {
                        path: "daily-check-journal",
                        children: [
                            {
                                index: true,
                                Component: DailyCheckJournal
                            },
                            {
                                path: ":clientId",
                                Component: DailyCheckJournal
                            }
                        ]
                    },


                    {
                        path: "employees",
                        children: [
                            {
                                index: true,
                                Component: Employees
                            },
                            { path: ":certificateNumber/:DepSequenceNumber/:activeTab?", Component: Employee },

                        ]
                    },
                    {
                        path: "claims",
                        Component: JvClaims
                    },
                    {
                        path: "reinsurance",
                        Component: JvReinsurance
                    },


                ]
            },

            {
                path: '/config',
                element: <ProtectedRoutes />,
                children: [


                    {
                        index: true,
                        path: "guide",
                        Component: HrpGuide
                    },
                    {
                        path: "accounts",
                        Component: Accounts
                    },
                    {
                        path: "account-hierarchy",
                        Component: AccountHierarchy
                    },
                    {
                        path: "account-builder",
                        children: [
                            {
                                index: true,
                                Component: AccountBuilder
                            },
                            {
                                path: ":accountId",
                                Component: AccountBuilderMultiStepForm
                            }
                        ]
                    },
                    {
                        path: "department-builder",
                        Component: DepartmentBuilder
                    },
                    {
                        path: "account-audit",
                        Component: AccountAudit
                    },
                    {
                        path: "audit",
                        Component: BenefitPlanAudit
                    },
                    {
                        path: "service-categories",
                        Component: ServiceCategories
                    },
                    {
                        path: "templates",
                        Component: Templates
                    },
                    {
                        path: "components",
                        Component: BenefitPlanComponents
                    },
                    {
                        path: "network-definitions",
                        Component: NetworkDefinitions
                    },


                    {
                        path: "value-list",
                        Component: ValueListTable
                    },
                    {
                        path: 'provisions',
                        Component: BenefitPlanProvision
                    },

                    // {
                    //     path: "components", Component: BenefitPlanComponent
                    // },
                    // {
                    //     path: "riders", Component: BenefitPlanRider
                    // },
                    // {
                    //     path: "builder-demo", Component: BenefitPlanBuilder
                    // },
                    {
                        path: "plan-builder",

                        children: [
                            {
                                index: true,
                                Component: BuilderDashboard
                            },
                            {
                                path: ":draftId",
                                Component: BenefitPlanMultiStepForm
                            }
                        ]

                    },

                    {
                        path: "migrate",
                        Component: MigrateBenefitPlan
                    },
                    {
                        path: "plans",
                        Component: BenefitPlans
                    },
                    // {
                    //     path: "builder-poc", Component: BenefitPlanBuilderPoc
                    // }

                ]
            },
            // {
            //     path: '/projects',
            //     Component: Projects
            // },



            // {
            //     path: "/bnft-plan-templates",
            //     children: [
            //         //      { index: true, Component: BenefitPlanTemplates },
            //         {
            //             path: ":bnftPlanTemplateHstFctKey", Component: BenefitPlanTemplatesDetail
            //         }
            //     ]
            // },
            // {
            //     path: "/bnft-plan-components",
            //     children: [
            //         { index: true, Component: BenefitPlanComponent },
            //         {
            //             path: ":todo", Component: BenefitPlanComponent
            //         }
            //     ]
            // },
            // {
            //     path: "/bnft-plan-rider",
            //     children: [
            //         { index: true, Component: BenefitPlanRider },
            //         {
            //             path: ":todo", Component: BenefitPlanRider
            //         }
            //     ]
            // },

            // {
            //     path: '/bntf-plan-builder',
            //     children: [
            //         { index: true, Component: BenefitPlanBuilder },
            //         {
            //             path: ":draftId", Component: BenefitPlanDraftReview
            //         }
            //     ]
            // },

            // {
            //     path: "/accounts",
            //     children: [
            //         { index: true, Component: Accounts },
            //         {
            //             path: ":id", Component: AccountDetails
            //         }
            //     ]
            // },




        ],
    },
    {
        path: '*', // This is the fallback route
        element: <NotFound />,
    },
]);


export {
    router
}
